import { Utils } from "@/plugins/utils"

export default {
    namespaced: true,
    state: {
        lstInc: [],
        inc: {},
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null,
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getInc(state) {
            let inc = { ...state.inc }
            return inc
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        },
    },
    mutations: {
        set(state, inc) {
            state.inc = inc || {}
            if (inc) state.update = true
        },
        initForm(state) {
            state.insert = false
            state.update = false
            state.inc = {}
        },
        setParamsDataTable(state, payload) {
            state.lstInc = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setInc(state, inc) {
            state.inc = inc
        },
        setLstInc(state, lstInc) {
            state.lstInc = lstInc
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },

        async find({ commit, dispatch }, incsubclas) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios
                .get(`/OryxPlace/SubClass/Find/${incsubclas}`)
                .then(response => {
                    let inc = Utils.ValidateAxiosResponse(response.data)
                    commit("set", inc)
                })
                .catch(error => {
                    dispatch(
                        "parameters/openDialog",
                        {
                            titleText: "Erro",
                            titleColor: "red",
                            text: error.message,
                        },
                        { root: true },
                    )
                })
            commit("setLoading", false)
        },

        async save({ getters, dispatch }, inc) {
            if (getters.getUpdate) {
                return await dispatch("update", inc)
            }
            return await dispatch("insert", inc)
        },

        async insert({ commit, dispatch }, inc) {
            dispatch(
                "parameters/openGlobalLoading",
                { showLoadingGlobal: true, text: "Salvando", indeterminate: true },
                { root: true },
            )
            let payload = await this._vm.$axios
                .post("/OryxPlace/SubClass/Insert", inc)
                .then(response => {
                    commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
                    commit("setInc", null)
                    return true
                })
                .catch(error => {
                    dispatch(
                        "parameters/openDialog",
                        {
                            titleText: "Erro",
                            titleColor: "red",
                            text: error.message,
                        },
                        { root: true },
                    )
                    return false
                })
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },

        async update({ commit, dispatch }, inc) {
            dispatch(
                "parameters/openGlobalLoading",
                { showLoadingGlobal: true, text: "Salvando", indeterminate: true },
                { root: true },
            )
            let payload = await this._vm.$axios
                .put("/OryxPlace/SubClass/Update", inc)
                .then(response => {
                    commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
                    return true
                })
                .catch(error => {
                    dispatch(
                        "parameters/openDialog",
                        {
                            titleText: "Erro",
                            titleColor: "red",
                            text: error.message,
                        },
                        { root: true },
                    )
                    return false
                })
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },

       async delete({ dispatch }, incsubclas) {
            dispatch(
                "parameters/openGlobalLoading",
                { showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
                { root: true }
            )

            try {
                const response = await this._vm.$axios.delete(
                `/OryxPlace/SubClass/Delete/${incsubclas}`
                )

                Utils.ValidateAxiosResponse(response.data)

                return true   
            }
            catch (error) {
                dispatch(
                "parameters/openDialog",
                {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message,
                },
                { root: true }
                )

                return false  
            }
            finally {
                dispatch(
                "parameters/openGlobalLoading",
                { showLoadingGlobal: false, text: "" },
                { root: true }
                )
            }
        },

        async search({ commit, dispatch, state, getters }, { limit = 20, page = 1 }) {
            dispatch(
                "parameters/openGlobalLoading",
                { showLoadingGlobal: true, text: "Buscando sub classes", indeterminate: true },
                { root: true },
            )
            commit("setLoading", true)
            commit("initForm")

            let url = `/OryxPlace/SubClass/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`

           
            let payload = await this._vm.$axios
                .get(url)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data)
                    commit("setParamsDataTable", payload)
                    return true
                })
                .catch(error => {
                    commit("setLstInc", [])
                    commit("setSearch", "")
                    dispatch(
                        "parameters/openDialog",
                        {
                            titleText: "Erro",
                            titleColor: "red",
                            text: error.message,
                        },
                        { root: true },
                    )
                    return false
                })
            commit("setLoading", false)
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },      
    },
}
